var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLocked(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7 8"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.87,3.16H5.14v-1C5.14,1,4.6.34,3.53.34S1.92,1,1.92,2.19v1H1.11a.48.48,0,0,0-.4.48V6.78a.6.6,0,0,0,.38.53l.48.16a3.51,3.51,0,0,0,.79.12H4.7a3.42,3.42,0,0,0,.78-.12L6,7.31a.6.6,0,0,0,.38-.53V3.64A.55.55,0,0,0,5.87,3.16Zm-1.53,0H2.72V2a.78.78,0,0,1,.81-.89A.78.78,0,0,1,4.34,2Z"
  })));
}

export default SvgLocked;